import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { Injectable } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation.service';

@Injectable({
  providedIn: 'root'
})
export class LocalUriGuardService {

  constructor(
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    //console.log (state.url);
    if (!state.url.endsWith(NavigationService.reportingUrl)) {
      return true;
    }
    return false;
  }

}
